import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { closeLazyPanel } from 'crazyEditor/redux/modules/panel/panel';

@connect(
  false, {closeLazyPanel}
)

export default class LazyComponent extends Component {
  componentDidMount() {
    const { onLoad } = this.props;
    if (onLoad) {
      onLoad();
    }
  }

  handleRequestClose = () => {
    const {closeLazyPanel, componentProps} = this.props;
    closeLazyPanel(componentProps.panelName);
  };

  render() {
    const { componentClass, componentProps } = this.props;
    return React.createElement(componentClass, {onClose: this.handleRequestClose, onRequestClose: this.handleRequestClose, ...componentProps});
  }
}

LazyComponent.propTypes = {
  componentClass: PropTypes.func.isRequired,
  componentProps: PropTypes.object,
  onLoad: PropTypes.func
};

LazyComponent.defaultProps = {
  componentProps: {}
};